import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';

export const fetchAbandonedReservationAction = createAction(
  type('[AbandonedReservation/API] Fetch abandoned reservation')
);

export const fetchAbandonedReservationSuccessAction = createAction(
  type('[AbandonedReservation/API] Fetch abandoned reservation success'),
  props<{ response: HistoryBookingDetail }>()
);

export const fetchAbandonedReservationErrorAction = createAction(
  type('[AbandonedReservation/API] Fetch abandoned reservation error')
);

export const cancelAbandonedReservationAction = createAction(
  type('[AbandonedReservation/API] Cancel abandoned reservation'),
  props<{ travelItineraryId: number }>()
);

export const cancelAbandonedReservationSuccessAction = createAction(
  type('[AbandonedReservation/API] Cancel abandoned reservation success')
);

export const cancelAbandonedReservationErrorAction = createAction(
  type('[AbandonedReservation/API] Cancel abandoned reservation error')
);
